import $http from "../axios";

const state = {
  settlements: [],
  settlementValues: []
};

const getters = {
  settlements: state => {
    return state.settlements;
  },

  settlementValues: state => {
    return state.settlementValues;
  }
};

const actions = {
  getSettlements({ commit }, { date, storeId }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`settlements?date=${date}&storeId=${storeId}`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_SETTLEMENTS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_SETTLEMENTS(state, payload) {
    state.settlements = payload.settlements;
    state.settlementValues = payload.settlementValues;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
